import { styled } from '@mui/material/styles';
import { TableCell, TableRow, TableRowProps } from '@mui/material';

export const StyledTableRow = styled(TableRow)((props: TableRowProps & { isParent?: boolean }) =>`
  background-color: ${props.isParent ? '#f4f4f4' : 'transparent'};
  position: sticky;
  top: 0;
`);

export const HeadingCell = styled(TableCell)`
  font-weight: 600;
  white-space: nowrap;
`;